import Chip from '@mui/material/Chip';

import { TicketTypeEnum } from '@/types/enums/ticket-type.enum';
import { t } from '@/utils/lang';

export interface StatusChipProps {
    status: TicketTypeEnum;
    size?: 'small' | 'medium';
    showChip?: boolean;
}

const ChipTicketType = ({
    status,
    size = 'medium',
    showChip = true,
}: StatusChipProps) => {
    let label: string;
    let color:
        | 'info'
        | 'warning'
        | 'success'
        | 'error'
        | 'default'
        | 'primary'
        | 'secondary';

    switch (status?.toLowerCase()) {
        case TicketTypeEnum.INSTALLATION.toLowerCase():
        case 'check':
            label = 'Lắp đặt';
            color = 'primary';
            break;

        case TicketTypeEnum.SURVEY.toLowerCase():
        case 'check':
            label = 'Khảo sát';
            color = 'warning';
            break;

        case TicketTypeEnum.REPAIR.toLowerCase():
        case 'repair':
            label = 'Sửa chữa';
            color = 'success';
            break;

        case TicketTypeEnum.MAINTENANCE.toLowerCase():
        case 'maintenance':
            label = 'Bảo hành';
            color = 'info';
            break;

        default:
            label = 'Không xác định';
            color = 'default';
    }

    if (showChip) {
        return (
            <Chip variant='tonal' label={t(label)} color={color} size={size} />
        );
    }

    return {
        label: t(label, 'TicketType'),
        color,
    };
};

export default ChipTicketType;
